'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { capturePageview } from './client';
import { isPostHogEnabled } from './config';

/**
 * Sends `$pageview` on every client-side navigation.
 *
 * App Router navigation never reloads the document, so the SDK's own pageview
 * capture is disabled (`capture_pageview: false`) and this component owns it.
 *
 * Keyed on `usePathname()` rather than `useSearchParams()` on purpose: reading
 * search params in a client component forces a Suspense boundary and opts the
 * subtree out of static rendering. The query string is still reported — it is
 * read off `window.location` at capture time — so the only thing missed is a
 * navigation that changes *only* the query string.
 */
export function PostHogPageview() {
  const pathname = usePathname();

  useEffect(() => {
    if (!isPostHogEnabled()) return;
    const url = `${window.location.origin}${pathname}${window.location.search}`;
    capturePageview({ $current_url: url });
  }, [pathname]);

  return null;
}
